import PropTypes from 'prop-types';

import AttachmentsDownloadAll from 'components/lib/attachment/attachments_download_all';
import connect from 'components/lib/connect';

const AttachmentsDownloadAllContainer = connect(mapStateToProps)(AttachmentsDownloadAll);

AttachmentsDownloadAllContainer.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })).isRequired,
  pathPrefix: PropTypes.string.isRequired,
};

function mapStateToProps(context, { attachments, pathPrefix }) {
  let orgId = context
    .getProvider('auth')
    .get()
    .getOrgId();

  return {
    attachments,
    orgId,
    pathPrefix,
  };
}

export default AttachmentsDownloadAllContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/attachment/attachments_download_all_container.jsx